<template>
  <v-container id="page-business-log">
    <contents-layout>
      <template #title>
        <span></span>
      </template>
      <template #control>
        <vue-excel-xlsx
            id="excelDownloadButton1"
            :data="tableData"
            :columns="excelColumns1"
            :filename="excelFilename1"
            :sheetname="'차량운행일보'"
        />
        <vue-excel-xlsx
            id="excelDownloadButton2"
            :data="tableData"
            :columns="excelColumns2"
            :filename="excelFilename2"
            :sheetname="'수입일지'"
        />
      </template>
      <template #content>
        <template v-if="tableMode === 1">
          <c-card title="차량운행일보">
            <c-table
                :headers="tableHeader1" :items="tableData" multi-sort>
              <template #drivePeriod="{item}">
                {{ item.startHrMin }}<br>
                {{ item.endHrMin }}
              </template>
              <template #addr="{item}">
                <div>
                  <v-icon color="light2Grey" size="16">mdi-map-marker</v-icon>{{ item.addr0 }}
                </div>
                <template v-for="(waypointRoute, index) in item.waypointRouteList">
                    <div :key="index">
                      <v-icon color="black" size="16">mdi-map-marker</v-icon>{{ waypointRoute.position }}
                    </div>
                </template>
                <div>
                  <v-icon color="deepBlue" size="16">mdi-map-marker</v-icon>{{ item.addr1 }}
                </div>
              </template>
              <template #itemDistance="{ item }">
                {{ displayItemDistance(item.itemDistance).toFixed(3) }}
              </template>
              <template #totalFeeDisplay="{item}">
                {{ Number(item.totalFee).toLocaleString() }}
              </template>
            </c-table>
          </c-card>
        </template>

        <template v-if="tableMode === 2">
          <c-card title="수입일지">
            <c-table :headers="tableHeader2" :items="tableData" multi-sort>
              <template #waitFeeDisplay="{item}">
                {{ Number(item.waitFee).toLocaleString() }}
              </template>
              <template #driveFeeDisplay="{item}">
                {{ Number(item.driveFee).toLocaleString() }}
              </template>
              <template #serviceFeeDisplay="{item}">
                {{ Number(item.serviceFee).toLocaleString() }}
              </template>
              <template #extraFeeDisplay="{item}">
                {{ Number(item.extraFee).toLocaleString() }}
              </template>
              <template #discountFeeDisplay="{item}">
                {{ Number(item.discountFee).toLocaleString() }}
              </template>
              <template #deliveryFeeDisplay="{item}">
                {{ Number(item.deliveryFee).toLocaleString() }}
              </template>
              <template #paidFeeDisplay="{item}">
                {{ Number(item.paidFee).toLocaleString() }}
              </template>
              <template #unpaidFeeDisplay="{item}">
                {{ Number(item.unpaidFee).toLocaleString() }}
              </template>
              <template #totalFeeDisplay="{item}">
                {{ Number(item.totalFee).toLocaleString() }}
              </template>
            </c-table>
          </c-card>
        </template>
        <download-data-dialog
            :open.sync="downloadDataDialog"
        />
        <download-excel-dialog
            :open.sync="downloadExcelDialog"
            @reqDownloadExcel="reqDownloadExcel"
        />
      </template>
    </contents-layout>
  </v-container>
</template>

<script>
import DownloadExcelDialog from "../../Default/Common/DownloadExcelDialog";
import DownloadDataDialog from "@/views/CallTaxi/monitoring/DownloadDataDialog";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    DownloadExcelDialog,
    DownloadDataDialog
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: '',
    },
    downloadExcelDialog: {
      type: Boolean,
      default: false
    },
    downloadDataDialog: {
      type: Boolean,
      default: false
    },
    onlyUnpaid: {
      type: Boolean,
      default: false
    },
    tableMode: {
      type: Number,
      default: 1,
    },
    tables: {
      type: Array,
      default: () => ([
        {no:1, name: "차량운행일보"},
        {no:2, name: "수입일지"}
      ])
    },
  },
  data() {
    return {
      startMenu: false,
      endMenu: false,
      tableMenu: false,
      tableHeader1: [
        { text:'날짜', value: 'driveDate', align: 'center', sortable: true, },
        { text:'차량번호', value: 'plateNo', align: 'center', sortable: true, },
        { text:'차량모델', value: 'modelName', align: 'center', sortable: true, },
        { text:'기사이름', value: 'driverName', align: 'center', sortable: true, },
        { text:'총 주행 시간', value: 'drivePeriod', align: 'center', sortable: true, },
        { text:'주행구간', value: 'addr', align: 'center', sortable: false, },
        { text:'출발지', value: 'addr0', align: ' d-none', sortable: false, },
        { text:'도착지', value: 'addr1', align: ' d-none', sortable: false, },
        { text:'주행거리(km)', value: 'itemDistance', align: 'center', sortable: false, },
        { text:'예약자', value: 'customerName', align: 'center', sortable: false, },
        { text:'탑승 인원(명)', value: 'riderCount', align: 'center', sortable: false, },
        { text:'이용 건수(건)', value: 'usingCnt', align: 'center', sortable: false, },
        { text:'이용자 수(명)', value: 'userCnt', align: 'center', sortable: false, },
        { text:'최종 요금(원)', value: 'totalFeeDisplay', align: 'center', sortable: false, }
      ],
      tableHeader2: [
        { text:'날짜', value: 'driveDate', align: 'center', sortable: true, },
        { text:'구분', value: 'category', align: 'center', sortable: false, },
        { text:'예약자', value: 'customerName', align: 'center', sortable: false, },
        { text:'기사명', value: 'driverName', align: 'center', sortable: true, },
        { text:'담당차량', value: 'vehicleNo', align: 'center', sortable: true, },
        { text:'대기요금(원)', value: 'waitFeeDisplay', align: 'center', sortable: false, },
        { text:'주행요금(원)', value: 'driveFeeDisplay', align: 'center', sortable: false, },
        { text:'도움요금(원)', value: 'serviceFeeDisplay', align: 'center', sortable: false, },
        { text:'추가요금(원)', value: 'extraFeeDisplay', align: 'center', sortable: false, },
        { text:'할인요금(원)', value: 'discountFeeDisplay', align: 'center', sortable: false, },
        { text:'배송요금(원)', value: 'deliveryFeeDisplay', align: 'center', sortable: false, },
        { text:'실 결제요금(원)', value: 'paidFeeDisplay', align: 'center', sortable: false,},
        { text:'미수금(원)', value: 'unpaidFeeDisplay', align: 'center', sortable: false, },
        { text:'최종 요금(원)', value: 'totalFeeDisplay', align: 'center', sortable: false, },
        { text:'결제 수단', value: 'payMethodName', align: 'center', sortable: false, }
      ],
      driveLog: [],
      incomeData: [],
      tableData: [],
      excelColumns1 : [
        { label: "날짜", field: "driveDate", },
        { label: "차량번호", field: "plateNo" },
        { label: "차량모델", field: "modelName"},
        { label: "기사이름", field: "driverName" },
        { label: "출발시간", field: "startHrMin" },
        { label: "도착시간", field: "endHrMin" },
        { label: "출발지", field: "addr0" },
        { label: "경유지", field: "waypointRoutes"},
        { label: "도착지", field: "addr1" },
        { label: "주행거리(km)", field: "itemDistance" },
        { label: "예약자", field: "customerName" },
        { label: "탑승 인원(명)", field: "riderCount" },
        { label: "이용 건수(건)", field: "usingCnt" },
        { label: "이용자 수(명)", field: "userCnt" },
        { label: "최종요금", field: "totalFee" }
      ],
      excelColumns2 : [
        { label: "날짜", field: "driveDate", },
        { label: "구분", field: "category", },
        { label: "예약자", field: "customerName", },
        { label: "기사명", field: "driverName" },
        { label: "담당차량", field: "vehicleNo" },
        { label: "대기요금(원)", field: "waitFee", },
        { label: "주행요금(원)", field: "driveFee", },
        { label: "도움요금(원)", field: "serviceFee", },
        { label: "추가요금(원)", field: "extraFee", },
        { label: "할인요금(원)", field: "discountFee", },
        { label: "배송요금(원)", field: "deliveryFee", },
        { label: "실 결제 요금(월)", field: "paidFee" },
        { label: "미수금(원)", field: "unpaidFee" },
        { label: "최종 요금(원)", field: "totalFee" },
        { label: "결제 수단", field: "payMethodName" }
      ],
    }
  },
  mounted() {
      this.reqTableData();
  },
  watch: {
    startDate: function () {
      this.reqTableData();
    },
    endDate: function () {
      this.reqTableData();
    },
    tableMode: function() {
      this.reqTableData();
      this.filterTableData();
    },
    onlyUnpaid: function() {
      this.filterTableData();
    },
    downloadExcelDialog(newVal) {
      this.$emit('update:downloadExcelDialog', newVal)
    },
    downloadDataDialog(newVal) {
      this.$emit('update:downloadDataDialog', newVal)
    }
  },
  computed: {
    excelFilename1() {
      if ( this.startDate == this.endDate ) {
        return "차량운행일보_"+this.startDate;
      } else {
        return "차량운행일보_"+this.startDate+"_"+this.endDate;
      }
    },
    excelFilename2() {
      if ( this.startDate == this.endDate ) {
        return "수입일지_"+this.startDate;
      } else {
        return "수입일지_"+this.startDate+"_"+this.endDate;
      }
    },
    sortByDate() {

    }
  },
  methods: {
    async reqTableData() {
        try {
          this.$emit('update:loading', true);
          const res = await this.$api.getDriveLogStatusIsAndStartTimeBetween("ds_done", this.startDate, this.endDate);
          const res2 = await this.$api.getIncomeReportsData(this.startDate, this.endDate, this.keyword);

          if(this.tableMode == 1){
            this.driveLog = res.data.map((item, idx) => {
              item.idx = idx;
              item.driveDate = item.startTime ? this.$func.dateToString(item.startTime) : '';
              item.driverName = item.driver.name;
              item.plateNo = item.vehicle.plateNo;
              item.modelName = item.vehicle.vehicleModel ? item.vehicle.vehicleModel.modelName : '--';
              item.startHrMin = this.displayTime(item.startTime);
              item.endHrMin = this.displayTime(item.endTime);
              item.totalPaidFee = item.totalFee;
              item.totalUnpaidFee = item.unpaidFee;
              item.payMethodName = item.payMethod ? item.payMethod.configName : '-';
              item.addr0 = item.reservationRouteList.length > 0 ? item.reservationRouteList[0].position : '-';
              item.addr1 = item.reservationRouteList.length > 1 ? item.reservationRouteList[1].position : '-';
              item.waypointRoutes = item.waypointRouteList.reduce((acc, waypoint, index) => {
                if (item.waypointRouteList.length - 1 === index) {
                  return acc + waypoint.position;
                }
                return acc + waypoint.position + '\r\n';
              }, ''); // 엑셀 데이터용

              let distance = 0;
              if (item.selectedDistanceType) {
                switch (item.selectedDistanceType.configValue) {
                  case 'sdt_obd':
                    distance = item.collectedTotalDistance;
                    break;
                  case 'sdt_api':
                    distance = item.apiSupportedDistance;
                    break;
                  case 'sdt_odo':
                    distance = item.odoDistance;
                    break;
                  default:
                    distance = item.totalDistance;
                }
              } else {
                distance = item.collectedTotalDistance != null ? item.collectedTotalDistance : item.totalDistance;
              }
              item.itemDistance = Number(distance/1000);

              return item;
            });
          } else {
            this.incomeData = res2.data.map((item2, idx) => {
              item2.idx = idx;
              item2.driveDate = item2.driveDate ? this.$func.dateToString(item2.driveDate) : '';
              item2.payMethodName = item2.payMethodName.includes('현금') ? '현금결제' : item2.payMethodName.includes('카드') ? '카드결제' : item2.payMethodName.includes('삼성') ? '삼성페이결제' : item2.payMethodName;

              return item2;
            });
          }

          await this.filterTableData();
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqTableData'});
        } finally {
          this.$emit('update:loading', false);
        }
    },

    async filterTableData() {
      this.tableData = [];
      if(this.tableMode === 1){
        this.driveLog.map(item => {
          if ( item.driverName.indexOf(this.keyword) > -1 || item.plateNo.indexOf(this.keyword) > -1 ) {
            if ( !this.onlyUnpaid || item.totalUnpaidFee != 0 ) {
              this.tableData.push(item);
            }
          }
        })
      } else {
        this.incomeData.map(item2 => {
          if (item2.driverName.indexOf(this.keyword) > -1 || item2.vehicleNo.indexOf(this.keyword) > -1) {
              this.tableData.push(item2);
          }
        });
      }
    },
    async reqDownloadExcel() {
      document.getElementById("excelDownloadButton"+this.tableMode).click();
      this.downloadExcelDialog = false;
    },
    displayTime(str) {
      return str ? this.$moment(str).format("HH:mm") : "";
    },
    displayPeriod(str0, str1) {
      return this.$moment(str0).format("HH:mm")+"~"+this.$moment(str1).format("HH:mm");
    },
    displayTotalDistance(distance) {
      return distance > 0 ? Math.round(distance * 1.0 / 10) / 100 : 0;
    },
    displayItemDistance(distance) {
      return distance > 0 ? Number(distance):  0;
    },
    displayDuration(sec) {
      let hours   = Math.floor(sec / 3600);
      let minutes = Math.floor((sec - (hours * 3600)) / 60);

      return hours + '시간 ' + minutes + '분 '
    }
  }
}
</script>
<style scoped>
</style>
